<template>
  <div class="county-form">
    <el-dialog title="报名县域代理商" :visible.sync="visbility" width="30%" center>
      <el-form
        :model="countyForm"
        :rules="rules"
        ref="countyForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="您的姓名" prop="username">
          <el-input v-model="countyForm.username"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="countyForm.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄" prop="age">
          <el-input v-model="countyForm.age"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="countyForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="从事行业" prop="industry">
          <el-input v-model="countyForm.industry"></el-input>
        </el-form-item>
        <el-form-item label="周转资金" prop="money">
          <el-input v-model="countyForm.money">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="管理经验(人数)" prop="manage">
          <el-input v-model="countyForm.manage"></el-input>
        </el-form-item>
        <el-form-item label="所在城市" prop="city">
          <el-input v-model="countyForm.city"></el-input>
        </el-form-item>
        <el-form-item label="合作县域" prop="county">
          <el-input v-model="countyForm.county"></el-input>
        </el-form-item>

        <el-form-item label="图片验证" prop="captcha">
          <el-input v-model="countyForm.captcha" style="width:200px;"></el-input>
          <img :src="captchaSrc" />
          <i class="el-icon-refresh" @click="refresh"></i>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="commit">提交资料</el-button>
        <div style="display:flex;width:170px;margin:20px auto;">
          <img src="@/assets/images/new-img/driver/tel-ioc.png" width="29" />
          <div class="tel">010-5823 0628</div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinsVerification } from "@/mixins/verification";
export default {
  name: "countyForm",
  props: {
    dialogVisbility: Boolean
  },
  mixins: [mixinsVerification],
  data() {
    var checkTel = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("请输入正确的手机号码"));
      }
      callback();
    };
    var checkAge = (rule, value, callback) => {
      if (isNaN(value) || value > 100 || value < 18) {
        return callback(new Error("请输入正确的年龄"));
      }
      callback();
    };
    var checkManage = (rule, value, callback) => {
      if (isNaN(value) || value < 1) {
        return callback(new Error("请输入正确的人数"));
      }
      callback();
    };
    var checkMoney = (rule, value, callback) => {
      if (isNaN(value) || value < 1) {
        return callback(new Error("请输入正确的周转资金"));
      }
      callback();
    };
    return {
      countyForm: {
        username: "",
        gender: "",
        age: "",
        mobile: "",
        industry: "",
        money: "",
        manage: "",
        city: "",
        county: "",
        captcha: ""
      },
      visbility: this.dialogVisbility,
      rules: {
        username: [
          { required: true, message: "请输入您的姓名", trigger: "blur" }
        ],
        gender: [{ required: true, message: "请输入性别", trigger: "blur" }],
        age: [
          { required: true, message: "请输入年龄", trigger: "blur" },
          { validator: checkAge, trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ],
        industry: [
          { required: true, message: "请填写从事行业", trigger: "blur" }
        ],
        money: [
          { required: true, message: "请填写周转资金", trigger: "blur" },
          { validator: checkMoney, trigger: "blur" }
        ],
        manage: [
          { required: true, message: "请填写管理经验", trigger: "blur" },
          { validator: checkManage, trigger: "blur" }
        ],
        city: [{ required: true, message: "请填写所在城市", trigger: "blur" }],
        county: [
          { required: true, message: "请填写合作县域", trigger: "blur" }
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  methods: {
    commit() {
      this.$refs.countyForm.validate(valid => {
        if (valid) {
          let captcha = this.countyForm.captcha;
          let pramas = Object.assign({}, this.countyForm);
          delete pramas.captcha;
          _api.all.createCountyPartner(pramas, { captcha }).then(res => {
            this.visbility = false;
            this.refresh();
            this.$message({
              message: "提交信息成功",
              type: "success"
            });
            this.$refs.countyForm.resetFields();
          });
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    visbility(val) {
      this.$emit("update:dialogVisbility", val);
    },
    dialogVisbility(val) {
      this.visbility = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.tel {
  margin: 5px auto;
  width: 300px;
  font-size: 18px;
  color: #757575;
}
</style>
<style lang="scss">
.county-form {
  .el-dialog {
    width: 800px !important;
    border-radius: 8px;
    .el-dialog__header {
      height: 120px;
      line-height: 100px;
      background: url(~@/assets/images/partner/t-line.png) no-repeat left bottom;
      .el-dialog__title {
        font-size: 30px;
      }
      .el-dialog__close {
        padding: 25px 20px 0 0;
        font-size: 36px;
      }
    }
    .el-dialog__body {
      text-align: initial;
      padding: 25px 150px 30px;
      .el-icon-refresh {
        font-size: 20px;
      }
    }
    .el-button {
      width: 280px;
      background: #64bd89;
    }
  }
}
</style>

